export const sentryConfig = {
  dsn: '',

  environment: 'production',

  // Performance Monitoring
  tracesSampleRate: 1.0,

  // Set tracePropagationTargets to control span generation
  // tracePropagationTargets: ['localhost', /^https:\/\/yourserver\.io\/api/],
  tracePropagationTargets: [],

  // Session Replay
  replaysSessionSampleRate: 0.1, // 10% of sessions will be recorded
  replaysOnErrorSampleRate: 1.0, // 100% of sessions with errors will be recorded

  // Additional options
  debug: false, // Set to true for debugging
  beforeSend(event: any) {
    // Filter or modify events before sending to Sentry
    return event;
  },
};
